<template>
    <div class="text-center text-muted">
        <loader :loading="true" class="sm:fa-lg mr-2" />
        <span>Constantly checking for stock changes</span>
        <button v-if="!mobile" v-tooltip="'The page will keep checking if you leave it open.'" type="button" class="focus:outline-none">
            <i class="fad fa-info-circle ml-1"></i>
        </button>
    </div>
</template>

<script>
export default {
    data: () => ({}),

    created() {
        //
    },

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
